(function () {
  function initBIS(sectionId) {
    const submitBtn = document.getElementById('ProductSubmitButton-' + sectionId);
    const bisWrapper = document.getElementById('klaviyo-bis-' + sectionId);
    if (!bisWrapper) return;

    const bisBtn = bisWrapper.querySelector('.klaviyo-bis-trigger');
    if (!bisBtn) return;

    // Dawn fires a bubbling 'variant:change' event from the variant picker.
    // Listen on the ProductInfo container so we catch it regardless of picker type.
    const productInfo = document.getElementById('ProductInfo-' + sectionId);
    if (productInfo) {
      productInfo.addEventListener('variant:change', function (event) {
        const variant = event.detail && event.detail.variant;
        if (!variant) return;

        const isOOS = !variant.available;

        // Keep variant ID in sync so Klaviyo receives the right variant.
        bisBtn.dataset.variantId = variant.id;

        if (submitBtn) submitBtn.classList.toggle('hidden', isOOS);
        bisWrapper.classList.toggle('hidden', !isOOS);
      });
    }

    bisBtn.addEventListener('click', function () {
      const formId = bisWrapper.dataset.formId;
      if (!formId) {
        console.warn(
          '[Klaviyo BIS] No form ID set. Add your Klaviyo Back in Stock form ID ' +
          'in the Theme Editor → Product page → Buy buttons block.'
        );
        return;
      }
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    });
  }

  // Run after DOM is ready; the script is loaded with defer so this fires immediately.
  document.querySelectorAll('[id^="klaviyo-bis-"]').forEach(function (wrapper) {
    var sectionId = wrapper.id.replace('klaviyo-bis-', '');
    initBIS(sectionId);
  });
})();
